import React from 'react';

import {Light as SyntaxHighlighter} from 'react-syntax-highlighter';
import js from 'react-syntax-highlighter/dist/esm/languages/hljs/javascript';
import python from 'react-syntax-highlighter/dist/esm/languages/hljs/python';
import a11ydark from 'react-syntax-highlighter/dist/esm/styles/hljs/a11y-dark';

import './footnotes.css';


SyntaxHighlighter.registerLanguage('javascript', js);
SyntaxHighlighter.registerLanguage('python', python);


function ResponsiveImage({desktopSource, mobileSource, alt}) {
    return <>
        <img src={desktopSource} className='desktop' alt={alt}/>
        <img src={mobileSource} className='mobile' alt={alt}/>
    </>;
}


function Footnotes({children}) {
    return <section className='footnotes'>
        <hr/>
        <h2>Footnotes</h2>
        <ol>
            {children}
        </ol>
    </section>;
}

function Footnote({children, id}) {
    return <li>
        <span className='label'>[{id}]</span>
        {children}
        <a className='reference return' href={`#reference-${id}`}>↩</a>
        <span className='anchor' id={`footnote-${id}`}/>
    </li>;
}

function Ref({id}) {
    return <a
        className='reference'
        href={`#footnote-${id}`}
    >
        <sup>[{id}]</sup>
        <span className='anchor' id={`reference-${id}`}/>
    </a>;
}

function Code({children, language, start}) {
    return <SyntaxHighlighter
        language={language}
        style={a11ydark}
        showLineNumbers
        startingLineNumber={start || 1}
    >
        {children}
    </SyntaxHighlighter>
}

export {
    ResponsiveImage,
    Footnotes, Footnote, Ref,
    Code
};
